"use client";

import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Erro global da aplicacao:", error);
  }, [error]);

  return (
    <html lang="pt-br">
      <body>
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 3,
            bgcolor: "background.default",
          }}
        >
          <Paper
            elevation={0}
            variant="outlined"
            sx={{ p: 4, maxWidth: 600, width: "100%" }}
          >
            <Stack spacing={2}>
              <Typography variant="h4" fontWeight={700}>
                Algo deu errado
              </Typography>
              <Typography color="text.secondary">
                Ocorreu uma falha inesperada na aplicacao. Voce pode tentar
                recarregar agora.
              </Typography>
              <Button
                variant="contained"
                startIcon={<RefreshIcon />}
                onClick={reset}
              >
                Recarregar aplicacao
              </Button>
            </Stack>
          </Paper>
        </Box>
      </body>
    </html>
  );
}
